import React from 'react';
import './featuredexh.css'
import CircleCta from './circleviewcta';

const Featuredexh = (props) => {
    return ( 
        <article className='row-sec5'>
            <figure className='container-img'>
                <img className='right-imgg-sec6' src={props.img} alt={props.alt1}></img>
            </figure>
                    <img className='hover-img-sec5' src={props.img2} alt={props.alt2}></img> 
                <article className='sub-cont-sec5'>
                    <h2 className='sentence-sec5'>{props.title}</h2>
                    <article className='cont-article-secc5'>
                    <article className='container-booth-num'>
                        <h3 className='sentence2-sec5'>{props.booth}</h3>
                    </article>
                    </article>
                </article>
                <h2 className='category-sec5'>{props.category}</h2>
                <nav className='circle-contt-sec5'>
                <CircleCta />
                </nav>

               <article className='containerr-sec'>
                                    <article className='container-booth-num'>
                                        <h3 className='sentence2-sec5'>{props.booth}</h3>
                                        </article>
                                            <CircleCta />
                </article> 
        </article>
     );
}
 
export default Featuredexh;